export default __webpack_public_path__ + "assets/445d37271691662b93323b9acae3e67e.jpg";